import {RecordForm} from '../forms/RecordForm';
import {useBillingProvider} from '../hooks/useBillingProvider.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";
import {BillingProvider} from "../types.ts";

export const AddPage = () => {
    const { createRecord } = useBillingProvider();

    return (
        <FormPageLayout
            title='Add BillingProvider'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={{} as BillingProvider} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};